module.exports = __webpack_public_path__ + "img/LogoPerindo.02cd354a.png";